import React from 'react';
import { connect } from 'react-redux';
import { Field, InjectedFormProps, reduxForm } from 'redux-form';
import { Button, Card, CardBody, Col, FormGroup } from 'reactstrap';
import validate, { BookSectionCreateParams } from './validate';
import { AppState } from '@Redux/store';
import ReduxFormSelect from '@Utils/ReduxFormSelect';
import { BookSectionTypeView } from '@Selectors/publication/book-section/new/view/book-section-type.view';
import { FormattedMessage } from 'react-intl';
import { defaultMessages } from '@I18n/default';

interface Props {
  sections: BookSectionTypeView[],
  onSubmit: (values: any) => void,
  canSubmit: boolean,
}

const Form: React.FC<Props & InjectedFormProps<BookSectionCreateParams, Props>> = ({
                                                                                     sections,
                                                                                     handleSubmit,
                                                                                     canSubmit
                                                                                   }) => {
  return (
    <form onSubmit={handleSubmit}>
      <Card className='card-border'>
        <CardBody>
          <h3 className='text-center'><FormattedMessage {...defaultMessages.arsenalUnitFormTitle} /></h3>

          <FormGroup row={true}>
            <Col xs={12} md={6}>
              <Field
                name='type'
                type='text'
                datas={sections}
                component={ReduxFormSelect}
                label={defaultMessages.publicationBookSectionFormTypeTitle}
                placeHolder={defaultMessages.publicationBookSectionFormTypePlaceholder}
              />
            </Col>
          </FormGroup>
        </CardBody>

        <div className='mb-2 text-center'>
          <Button disabled={!canSubmit} color='age' type='submit'><FormattedMessage {...defaultMessages.formAdd}  /></Button>
        </div>
      </Card>
    </form>
  );
};

var BookSectionNewForm = reduxForm<BookSectionCreateParams, Props>({
  form: 'create_book_section',
  validate
})(Form);

const mapStateToProps = (_: AppState, props: Props) => {
  return {
    onSubmit: props.onSubmit,
    initialValues: {}
  };
};

export default connect(mapStateToProps)(BookSectionNewForm);
